import * as React from 'react';
import { Button, Grid, Loading, Modal, Text } from '@nextui-org/react';
import produce from 'immer';
import { useGetAllTagsLazyQuery } from '@src/generated/hooks';
import {
  AppFilterableList,
  AppFilterableListItem,
} from '@src/layouts/app/AppFilterableList';

interface ModalTagSelectProps {
  onCancel: () => void;
  onOk: (selectedItems?: AppFilterableListItem[]) => void;
  selected: string[];
  visible: boolean;
}

/**
 * @name ModalTagSelect
 * @description tbd...
 */
export function ModalTagSelect(props: ModalTagSelectProps) {
  const { onCancel, onOk, selected, visible } = props;

  // Hooks
  const [allItems, setAllItems] = React.useState<AppFilterableListItem[]>([]);

  // GraphQL
  const [getAllTags, { data, loading, refetch }] = useGetAllTagsLazyQuery();

  // Lifecycle
  React.useEffect(() => {
    if (visible) {
      refetch();
      getAllTags();
    }
  }, [visible]);

  React.useEffect(() => {
    if (data) {
      const items =
        data?.tags.map(({ id, name }) => {
          return {
            id,
            name,
            selected: selected.includes(name),
          };
        }) ?? [];

      setAllItems(items);
    }
  }, [data]);

  // Handlers
  const onItemSelect = (selectedItems?: AppFilterableListItem[]) => {
    setAllItems(
      produce(allItems, (draft) => {
        if (selectedItems) {
          draft.forEach((item) => {
            item.selected = selectedItems.some((i) => i.id === item.id);
          });
        }
      }),
    );
  };

  return (
    <Modal
      blur
      preventClose
      aria-labelledby="modal-title"
      open={visible}
      onClose={() => onCancel()}
    >
      <Modal.Header>
        <Text id="modal-title" size={18} b>
          Select Tag
        </Text>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loading />}
        {!loading && (
          <AppFilterableList
            title="CAMPAIGNS"
            items={allItems}
            onItemsSelect={onItemSelect}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Grid.Container gap={1}>
          <Grid xs={6} justify="center">
            <Button
              auto
              light
              color="error"
              css={{ w: 'stretch' }}
              onPress={onCancel}
            >
              Cancel
            </Button>
          </Grid>
          <Grid xs={6} justify="center">
            <Button
              auto
              css={{ w: 'stretch' }}
              onPress={() => onOk(allItems.filter((i) => i.selected))}
            >
              Ok
            </Button>
          </Grid>
        </Grid.Container>
      </Modal.Footer>
    </Modal>
  );
}
